import { AppConfig } from '@dh-io-emh/config-types';
import PreCheckoutStep from '../models/product-configuration.model';
import { createHttpService } from '../utils/http.util';
import { DCPPreCheckoutStepDTO } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';

export type PcpApi = ReturnType<typeof createPCPConfigApi>;

export const createPCPConfigApi = ({ config: { apiBaseUrl, lang, siteId } }: { config: AppConfig }) => {
  const http = createHttpService({
    url: `${apiBaseUrl}/v2/${siteId}`,
    params: { lang },
  });

  return {
    getPreCheckoutSteps: (productId: string) =>
      http
        .get<DCPPreCheckoutStepDTO[]>(`products/${productId}/precheckoutsteps`)
        .then((res) => res.data.map((step) => PreCheckoutStep.create(step))),
  };
};
